import * as PIXI from 'pixi.js';
import { IAnimationDependencies, IAnimation } from 'js/bubbleCore/view/animations/types';
import { fillAnimationDependencies } from 'js/bubbleCore/view/animations/fillAnimationDependencies';

export function createBubbleBurst(
  textures: PIXI.Texture[],
  dependencies: Partial<IAnimationDependencies> = {},
): IAnimation<PIXI.Sprite> {
  const { animatedPool, tweenMgr, rnd } = fillAnimationDependencies(dependencies);

  const root = animatedPool.getInstance().props({
    anchor: 0.5,
    scale: 2,
  })
  root.textures = textures;
  root.animationSpeed = 0.5;
  root.loop = false;
  const onCompleteAsync: Promise<void> = new Promise((resolve) => {
    root.onComplete = () => {
      animatedPool.release(root);
      resolve();
    };
  });
  root.play();

  return { root, onCompleteAsync, cancel: () => {} };
}